// extracted by mini-css-extract-plugin
module.exports = {"processing":"Healthscore_processing__oNNAV","healthscore":"Healthscore_healthscore__12z1E","icon":"Healthscore_icon__2sST8","dropdownContent":"Healthscore_dropdownContent__1SGMy"};